/**
 * Given a manager and a list of coadmins return CSV list of their names.
 *
 * If not first_name/last_name is available, fallback to email.
 *
 * Args:
 *
 *   manager (Object):
 *      - first_name (String)
 *      - last_name (String)
 *      - email (String)
 *
 *   coadmins (Array): Each the same fields as manager
 *
 * Returns e.g:
 *
 *   John Doe, Albert Einstein, frank.herbert@dune.com
 *
 */
export function makeAdminNamesString(manager, coadmins) {
  let adminsString = '';
  if (manager) {
    adminsString +=
      manager.first_name || manager.last_name
        ? manager.first_name + ' ' + manager.last_name
        : manager.email;
    if (coadmins && coadmins.length) {
      adminsString += ', ';
    }
  }
  if (coadmins) {
    for (let i = 0; i < coadmins.length; i++) {
      const coadmin = coadmins[i];
      adminsString +=
        coadmin.first_name || coadmin.last_name
          ? coadmin.first_name + ' ' + coadmin.last_name
          : coadmin.email;
      if (i < coadmins.length - 1) {
        adminsString += ', ';
      }
    }
  }
  return adminsString;
}

export default {
  computed: {
    managedUsers() {
      return this.$store.state.common.managedUsers;
    },
    manageUsersTabTitle() {
      return this.$store.getters.userIsBeingManaged
        ? this.$t('userManagementBeingManaged')
        : this.$t('userManagementManage');
    },
    manageUsersTabTitleShort() {
      return this.$store.getters.userIsBeingManaged
        ? this.$t('userManagementBeingManagedShort')
        : this.$t('userManagementManageShort');
    },
  },
  methods: {
    /**
     * Most usermanagement pages need current User and managed Users.
     *
     * That information may not yet be available when e.g. reloaded in
     * the browser, in that case we fetch it here.
     *
     * Args:
     *   opts (Object)
     *     force (Boolean): Force fetching no matter what
     */
    fetchUserDataAsNeeded(opts) {
      const force = opts ? opts.force : false;

      if (force || !this.$user) {
        this.$store.dispatch('RETRIEVE_CURRENT_USER');
      }
      if (force || !this.managedUsers.length) {
        this.loading = true;
        this.$store.dispatch('LIST_MANAGED_USERS').finally(() => {
          this.loading = false;
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/commonUsermanagement.js